import { render, staticRenderFns } from "./PointsPerTag.vue?vue&type=template&id=2df3610e"
import script from "./PointsPerTag.vue?vue&type=script&lang=ts"
export * from "./PointsPerTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports